import React from "react";
import { connect } from "react-redux";
import GiveRewardPopup from "./GiveRewardPopup";
import ResendInviteModal from "./ResendInviteModal";
import LockParticipantModal from "./LockParticipantModal";
import ChangeStatusModal from "./ChangeStatusModal";
import PeerAllocationPopup from "./PeerAllocationPopup";
import ParticipantViewModal from "./ParticipantViewModal";
import ReclaimPeerAllocationsModal from "./ReclaimPeerAllocationsModal"; 
import AddUserGoalModal from "./AddUserGoalModal";
// import SubProgramsModal from './subprogram/SubProgramsModal'
import { useTranslation } from "react-i18next";
import EditParticipantModal from "./EditParticipantModal";
import ParticipantAwardRevokeModal from "./ParticipantAwardRevokeModal"
import SendRewardModal from "./SendRewardModal";
import PhysicalCardModal from "./PhysicalCardModal";
import RequestReclaimModal from "./RequestReclaimModal";
import PendingApprovalModal from "./PendingApprovalModal";

const MainModalWrapper = ({
  user,
  organization,
  program,
  name,
  setRefreshUsers,
  isOpen,
  setOpen,
  toggle,
  participants,
  auth,
  template,
  balance,
  refreshBalance,
  refreshApprovals
}) => {
  const { t } = useTranslation();
  const props = {
    setRefreshUsers,
    isOpen,
    setOpen,
    toggle,
    organization,
    program,
    user,
    participants,
    auth,
    name,
    template,
    balance,
    refreshBalance,
    refreshApprovals
  };
  if (!organization?.id || !program?.id) return t("loading");
  return (
    <>
      {name === "Reward" && <GiveRewardPopup {...props} />}
      {name === "Row Reward" && ( <SendRewardModal  {...props} /> )}
      {name === "Resend Invite" && <ResendInviteModal {...props} />}
      {name === "Lock Participant" && <LockParticipantModal {...props} />}
      {(name === "Deactivate" || name === "Activate" || name === "Lock" || name === "Unlock") && (
        <ChangeStatusModal {...props} />
      )}
      {name === "Peer Allocation" && <PeerAllocationPopup {...props} />}
      {name === "Name" && <ParticipantViewModal {...props} />}
      {name === "Reclaim Peer Allocations" && <ReclaimPeerAllocationsModal {...props} />}
      {name === "Edit Participant" && <EditParticipantModal {...props} />}
      {name === "Add Goal" && <AddUserGoalModal {...props} />}
      {name === "Participant Award Revoke" && <ParticipantAwardRevokeModal {...props} />}
      {name === "Instant Reward" && <SendRewardModal {...props} /> }
      {name === "Order Physical Cards" && ( <PhysicalCardModal  {...props} /> )}
      {name === "Request Reclaim" && <RequestReclaimModal {...props} />}
      {name === "Pending Approval" && <PendingApprovalModal {...props} />}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    organization: state.organization,
    template: state.template,
  };
};
export default connect(mapStateToProps)(MainModalWrapper); 
